import React from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Helmet } from "react-helmet-async";
import Nosotros from './screens/Us';
import FAQ from './screens/FAQ';
import Ofertas from './screens/Ofertas';
import Verificacion from './screens/Verificacion';
import Thankyou from './screens/Thankyou';
import Banking from './screens/Banking';
import Home from './screens/Home';
import Terms from './screens/Terms';
import Wait from './screens/Wait';
import Busqueda from './screens/Busqueda';
import Subscription from './screens/Subscription';
import Collection from './screens/Collection';
import Metodo from './screens/Metodo';
import Firmadigital from './screens/Firmadigital';
import Oferta from './screens/Oferta';
import Biometria from './screens/BiometriaScreen';
import ValidacionBiometria from './screens/ValidacionBiometria';
import Confirm from './screens/Confirm';
import Ingresos from './screens/Ingresos';
import Expired from './screens/Expired';
import CBU from './screens/CBU';

import useFormStore from "./state/useFormStore";
import Rejected from './screens/Rejected';
import WhatsAppButton from './components/WhatsAppButton';
import ValidacionBiometriaOutside from './screens/ValidacionBiometriaOutside';

const Navigation = () => {
  const location = useLocation();
  const hashFromLocalStorage = localStorage.getItem('hash');
  const hashFromUrl = window.location.pathname.split('/')[1];
  const hash = useFormStore((state) => state.hash) || hashFromLocalStorage || hashFromUrl;
  // const hash = 'asdfadsfasdf'
  const navigate = useNavigate();
  // Redirigir a la página de inicio si no hay hash
  React.useEffect(() => {
    if (!hash) {
      navigate('/');
    }
  }, [hash, navigate]);

  React.useEffect(() => {
    const pathParts = location.pathname.split('/');
    const cleanPath = pathParts.length > 2 ? `solicitud/${pathParts[2]}` : location.pathname;
    const requestHash = pathParts[1] || '';

    // Google Tag Manager tracking
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        'event': 'page_view',
        'page_path': cleanPath + location.search,
        'page_title': document.title,
        'request_hash': requestHash,
        'page_location': window.location.href,
        'full_original_path': location.pathname + location.search
      });
    }
  }, [location]);

  // Verificar si la ruta actual incluye un hash
  const showWhatsAppButton = location.pathname.includes('/' + hash + '/');

  return (
    <TransitionGroup component={null}>
      <Helmet>
        <title>Prestix - Te presto más rápido y 100% online</title>
        <meta name="description" content=" ¡Tu confianza es nuestra garantía! Préstamos simples y transparentes. ¡Sin complicaciones! Solicita tu préstamo personal hoy mismo." />
        <link rel="canonical" href="#" />
        <meta
          name="keywords"
          content="Préstamos, Créditos, Ahorro, Planes de Ahorro, Servicios Financieros, Inversiones, Fintech, Créditos Online, Préstamos Online"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Prestix - Te presto más rápido y 100% online"
        />
        <meta
          property="og:description"
          content=" ¡Tu confianza es nuestra garantía! Préstamos simples y transparentes. ¡Sin complicaciones! Solicita tu préstamo personal hoy mismo."
        />
        <meta property="og:url" content="#" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="#"
        />
      </Helmet>
      <CSSTransition
        key={location.key}
        classNames="fade"
        timeout={500}
      >
        <Routes location={location}>
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terminos" element={<Terms />} />
          <Route path={`/expirado`} element={<Expired />} />
          <Route path={`/validacion-exitosa`} element={<ValidacionBiometriaOutside />} />
          <Route path={`/continuar`} element={<Home />} />
          <Route path={`/:hash/espera`} element={<Wait />} />
          <Route path={`/:hash/buscando`} element={<Busqueda />} />
          <Route path={`/:hash/cbu`} element={<CBU />} />
          <Route path={`/:hash/rechazado`} element={<Rejected />} />
          <Route path={`/:hash/expirado`} element={<Expired />} />
          <Route path={`/:hash/ofertas`} element={<Ofertas />} />
          <Route path={`/:hash/oferta`} element={<Oferta />} />
          <Route path={`/:hash/confirmacion`} element={<Thankyou />} />
          <Route path={`/:hash/tarjeta`} element={<Collection />} />
          <Route path={`/:hash/biometria`} element={<Biometria />} />
          <Route path={`/:hash/ingresos`} element={<Ingresos />} />
          <Route path={`/:hash/firma`} element={<Firmadigital />} />
          <Route path={`/:hash/validacion-exitosa`} element={<ValidacionBiometria />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </CSSTransition>
      {showWhatsAppButton && <WhatsAppButton />}
    </TransitionGroup>
  );
};

export default Navigation;